module.exports = __webpack_public_path__ + "img/20190523202427微信截图_20190523202818.95a1d88f.png";